const maintenanceEquipments = {
  toastr: 'Equipamentos atualizados',
  toastr1: 'Equipamentos ENVIADOS para manutenção com sucesso',
  toastr2: 'Equipamentos RETORNADOS para manutenção com sucesso',
};

export default maintenanceEquipments;
